import { Provider } from '@angular/core';

import { ReportsService } from '@reports/services/reports.service';
import { REPORTS_STORE } from '@reports/stores/reports.store';

export const REPORTS_PROVIDERS: Provider[] = [ReportsService, REPORTS_STORE];
